if (!customElements.get('preorder-cart-toggle')) {
  class PreorderCartToggle extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateUnsubscriber = undefined;
    }

    connectedCallback() {
      this.preorderButtons = this.querySelectorAll('[data-preorder-button]');
      this.cartButton = this.querySelector('[data-cart-button]');

      if (!this.cartUpdateUnsubscriber && window.theme && theme.pubsub) {
        this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          this.onCartUpdate.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = undefined;
      }
    }

    onCartUpdate(event) {
      if (!event || !event.cart || event.cart.errors) return;
      this.updateVisibility(event.cart.item_count);
    }

    updateVisibility(itemCount) {
      const hasItems = parseInt(itemCount, 10) > 0;

      if (this.cartButton) {
        this.cartButton.hidden = !hasItems;
      }
      this.preorderButtons.forEach((button) => {
        button.hidden = hasItems;
      });
    }
  }

  customElements.define('preorder-cart-toggle', PreorderCartToggle);
}
